export default "__VITE_ASSET__DhI0kkJX__"